import { gql } from '@apollo/client';

import { BREAKDOWN_FIELDS } from 'gql/breakdownFragment';

export const FETCH_WORK_ASSIGNMENT = gql`
	query fetchWorkAssignment($filter: WorkAssignmentSearchFilterV2!, $pagination: PaginationInput!) {
		workAssignmentSearchV2(pagination: $pagination, filter: $filter) {
			results {
				sequenceGroupId
				reconciliationStatus
				isProblematic
				status
				crewMember {
					id
					fullName
					driverCard
				}
				run {
					id
					name
				}
				job {
					code
					distanceKm
					durationSeconds
				}
				breakdown {
					...BreakdownFields
				}
				workAssignmentSequences {
					sequenceGroupId
					ride {
						id
						tripNumber
						lineCode
						departure
						stations {
							id
							code
							name
							departure
							arrival
							timezone
							isOperational
						}
					}
					line {
						code
					}
					workAssignments {
						id
						version
						fromTimestamp
						toTimestamp
						fromStation {
							code
							name
						}
						toStation {
							code
							name
						}
					}
					fromTimestamp
					toTimestamp
					fromStation {
						id
						code
						name
						timezone
					}
					toStation {
						id
						code
						name
						timezone
					}
					status
					extraActivities {
						status
						activityType
						fromStation {
							id
							code
						}
						toStation {
							id
							code
						}
						fromTimestamp
						toTimestamp
					}
				}
			}
		}
	}
	${BREAKDOWN_FIELDS}
`;
